import { WtrRootState } from 'redux/create-store';

export const selectBanners = (state: WtrRootState) => state.adtech.byCategory;
